module.exports = __webpack_public_path__ + "img/mobile-download-ios.bd011fe1.webp";